import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { env } from '@/config/env';
import { reactQueryKeys } from '@/config/react-query';
import { useCodWeb } from '@/hooks/use-codweb';
import { getApiHeaders } from '@/lib/getApiHeaders';

const AsteriskUrlSchema = z.string().min(1);

const GetAsteriskUrlSchema = z.object({
  asteriskUrl: AsteriskUrlSchema,
});

const getAsteriskUrl = async (params: { codWeb: string }) => {
  const route = `${env.VITE_BACKEND_URL}/api/${params.codWeb}/asterisk-url`;
  const headers = await getApiHeaders();

  const response = await fetch(route, { headers });

  if (!response.ok) {
    throw new Error(
      `Fetch failed for route ${route} with headers ${headers} with status ${response.status}`
    );
  }

  const json = await response.json();
  const { asteriskUrl } = GetAsteriskUrlSchema.parse(json);

  return asteriskUrl.startsWith('wss://')
    ? asteriskUrl
    : `wss://${asteriskUrl}`;
};

export const useAsteriskUrl = () => {
  const codWeb = useCodWeb();

  return useQuery({
    queryKey: [reactQueryKeys.asteriskUrl, String(codWeb)],
    queryFn: () => getAsteriskUrl({ codWeb }),
    enabled: Boolean(codWeb),
    retry: true,
    staleTime: Infinity,
  });
};
